import React from 'react';
import { RCAlertBox, RCFlex, RCIcon, RCText } from '@reverbdotcom/cadence/components';
import { WarningIcon } from '@reverbdotcom/cadence/icons/react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';

const GET_PAID_WITH_PAYPAL_HELP_CENTER_ARTICLE_ID = '41988411420699';

function PaypalPayoutsAnnouncement() {
  const helpCenterArticleUrl = useHelpCenterArticleUrl(GET_PAID_WITH_PAYPAL_HELP_CENTER_ARTICLE_ID);

  return (
    <div className="margin-4">
      <RCAlertBox type="warning">
        <RCFlex gap="4">
          <RCIcon
            icon={<WarningIcon />}
            size="rc-space-10"
          />
          <div>
            <RCText weight="bold" htmlTag="span">
              <Translate text="discovery.paypalPayoutsAnnouncement.trackingInfoRequired" />
            </RCText>
            {' '}
            <RCText htmlTag="span">
              <Translate text="discovery.paypalPayoutsAnnouncement.shippingInstructions" />
            </RCText>
            {' '}
            <a href={helpCenterArticleUrl} target="_blank" className="text-link" rel="noreferrer">
              <RCText htmlTag="span">
                <Translate text="discovery.paypalPayoutsAnnouncement.learnMore" />
              </RCText>
            </a>
          </div>
        </RCFlex>
      </RCAlertBox>
    </div>
  );
}
export default PaypalPayoutsAnnouncement;
